// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1gyCp","row":"Node_row__l7XSN","label":"Node_label__1Dmfm","footer":"Node_footer__2GgEW"};